import React from 'react';
import BasketItemsLayout from './components/BasketItemsLayout';
import PerformanceCardSkeleton from '../../components/PerformanceCardSkeleton';
import EntityCardSkeleton from '../../components/EntityCardSkeleton';

// Full-tab shimmer — Performance card + the 2 entity cards Basket Items V1
// renders below it (basket items table + referrers). Matches the final
// layout so users see the card count while the fetch resolves.
const TabSkeleton = () => (
  <>
    <PerformanceCardSkeleton />
    <div style={{ marginTop: 10 }}>
      <EntityCardSkeleton />
    </div>
    <div style={{ marginTop: 10 }}>
      <EntityCardSkeleton />
    </div>
  </>
);

const BasketItemsTab = ({
  colStyle,
  selectedCampaign,
  chartsLoading,
  campaignOrder,
  chartData,
  bySignUpRangeDate,
  setSignUpRangeDate,
  dataSignUpRangeDate,
  setDataSignUpRangeDate,
  setbySignUpsAttributionWindow,
  setdataSignUpsDate,
  bySignUpsAttributionWindow,
  dataSignUpsDate,
  reportName,
  attributionWindow,
  setAttributionWindow,
  searchTerm,
  setSearchTerm,
  campaignOrderId,
  currentUser,
}) => {
  if (chartsLoading) return <TabSkeleton />;

  return (
    <BasketItemsLayout
      colStyle={colStyle}
      selectedCampaign={selectedCampaign}
      campaignOrder={campaignOrder}
      chartData={chartData}
      bySignUpRangeDate={bySignUpRangeDate}
      setSignUpRangeDate={setSignUpRangeDate}
      dataSignUpRangeDate={dataSignUpRangeDate}
      setDataSignUpRangeDate={setDataSignUpRangeDate}
      setbySignUpsAttributionWindow={setbySignUpsAttributionWindow}
      setdataSignUpsDate={setdataSignUpsDate}
      bySignUpsAttributionWindow={bySignUpsAttributionWindow}
      dataSignUpsDate={dataSignUpsDate}
      permission={currentUser.permission}
      reportName={reportName}
      attributionWindow={attributionWindow}
      setAttributionWindow={setAttributionWindow}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      campaignOrderId={campaignOrderId}
      chartsLoading={chartsLoading}
    />
  );
};

export default BasketItemsTab;
